var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.167 110.833C134.167 113.928 132.938 116.895 130.75 119.083C128.562 121.271 125.594 122.5 122.5 122.5H17.5002C14.406 122.5 11.4385 121.271 9.25058 119.083C7.06266 116.895 5.8335 113.928 5.8335 110.833V46.6667C5.8335 43.5725 7.06266 40.605 9.25058 38.4171C11.4385 36.2292 14.406 35 17.5002 35H40.8335L52.5002 17.5H87.5002L99.1668 35H122.5C125.594 35 128.562 36.2292 130.75 38.4171C132.938 40.605 134.167 43.5725 134.167 46.6667V110.833Z",
    stroke: "#001C40",
    strokeWidth: 11.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0002 99.1667C82.8868 99.1667 93.3335 88.72 93.3335 75.8333C93.3335 62.9467 82.8868 52.5 70.0002 52.5C57.1135 52.5 46.6668 62.9467 46.6668 75.8333C46.6668 88.72 57.1135 99.1667 70.0002 99.1667Z",
    stroke: "#001C40",
    strokeWidth: 11.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.272a4d6ffebc10d3725873003acb27b4.svg";
export { ForwardRef as ReactComponent };